import React, { useEffect } from "react";
import { useNavigate, useLocation } from "react-router";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { FileQuestion } from "lucide-react";
import { nanoid } from "nanoid";

export default function NotFound() {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {

    const logError = async () => {
      try {
        const currentUrl = window.location.pathname;

        const errorData = {
          type: "404",
          timestamp: new Date().toISOString(),
          url: currentUrl,
          message: `Client-side 404 encountered: ${currentUrl}`,
          stack: null,
          metadata: {
            referrer: document.referrer || null,
            userAgent: navigator.userAgent,
            pathname: location.pathname,
            search: location.search
          }
        };

        const response = await fetch('/api/logs/errors', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(errorData),
        });

        if (!response.ok) {
          console.error('Failed to log 404 error:', await response.text());
        }
      } catch (err) {
        console.error('Error logging 404:', err);
      }
    };

    // Log the 404 error
    logError();
  }, [location]);

  return (
    <div className="flex items-center justify-center min-h-[80vh] p-4">
      <Card className="w-full max-w-md shadow-lg">
        <CardHeader className="text-center">
          <div className="mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-destructive/10">
            <FileQuestion className="h-8 w-8 text-destructive" />
          </div>
          <CardTitle className="text-3xl font-bold">404</CardTitle>
          <CardDescription className="text-xl mt-2">Page Not Found</CardDescription>
        </CardHeader>
        <CardContent className="text-center">
          <p className="mb-6 text-muted-foreground">
            The page you're looking for doesn't exist or has been moved.
          </p>
          <div className="flex justify-center gap-4">
            <Button
              variant="outline"
              onClick={() => navigate(-1)}
            >
              Go Back
            </Button>
            <Button
              onClick={() => navigate("/")}
            >
              Home
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
